import { useState } from 'react';
import { Anchor, Box, Button, Card, Heading, Paragraph, Text } from '@zillow/constellation-10';
import StringConstants from '@common/constants/StringConstants';
import { logError } from '@zg-rentals/log-error';

interface HowSignUpProps {
  bold?: boolean;
}

const HowSignUp = ({ bold }: HowSignUpProps) => {
  const [buttonClicked, setButtonClicked] = useState(false);

  const copyToClipboard = () => {
    if (typeof window !== 'undefined') {
      const textToCopy =
        'Hi! I’d like to securely pay my rent online through ' +
        'Zillow. It’s free to you, and you’ll collect rent right in ' +
        'your bank account — so no more checks. Please do a quick, easy ' +
        'setup to invite me. Here are the details: ' +
        `${StringConstants.LINKS.MARKETING_PAGE.ZRM_PAYMENTS}?utm_campaign=renter_payments_lp_zillow`;
      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        logError({ error: err, context: 'Landing page: error copying text.' });
      }
      setButtonClicked(true);
      document.body.removeChild(textArea);
    }
  };

  return (
    <Box>
      <Box css={{ backgroundColor: bold ? '#e2effc' : '', textAlign: 'center', padding: '60px 16px' }}>
        <Box
          css={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 'default',
            textAlign: 'center',
            marginBottom: 'default',
          }}
        >
          <Heading
            level={2}
            textStyle="heading-sm"
            className={`Payments-LandingPage-HowSignUp-Header${bold ? '-Bold' : ''}`}
          >
            {bold ? 'Excited to pay rent online?' : 'How do I sign up?'}
          </Heading>
          {!bold && (
            <>
              <Text>It’s easy. Your landlord just has to invite you by setting up your rental property.</Text>
            </>
          )}
        </Box>
        <Box css={{ display: 'flex', justifyContent: 'center' }}>
          {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 660px` is past the end of the numeric sizes scale, which stops at `5000` (200px) */}
          <Card elevated={false} css={{ padding: '500', maxWidth: '660px' }}>
            <Paragraph css={{ marginBottom: 'default' }} textStyle="body-bold">
              Email or text your landlord this message to get started:
            </Paragraph>

            <Text color="text.subtle">
              Hi! I’d like to securely pay my rent online through Zillow. It’s free to you, and you’ll collect rent
              right in your bank account—so no more checks. Please do a quick, easy setup to invite me.
              <br />
              <br />
              Here are{' '}
              <Anchor href={StringConstants.LINKS.MARKETING_PAGE.ZRM_PAYMENTS} target="_blank">
                the details
              </Anchor>
              .
            </Text>
            <Box css={{ display: 'flex', justifyContent: 'center', marginTop: 'tighter' }}>
              <Button emphasis={buttonClicked ? 'outlined' : 'filled'} onClick={copyToClipboard}>
                {buttonClicked ? 'Copied' : 'Copy to clipboard'}
              </Button>
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default HowSignUp;
